import React from 'react';
import { i18n } from 'app/utils/i18n';
import LanguageIcon from './LanguageIcon';
import { Dropdown } from 'app/components';

export const langs = [
  { lang: 'sv', name: 'Svenska', labelKey: 'lang.sv', locale: 'sv-SE', systemLang: true },
  { lang: 'en', name: 'Engelska', labelKey: 'lang.en', locale: 'en-US', systemLang: true },
  { lang: 'da', name: 'Danska', labelKey: 'lang.da', locale: 'da-DK', systemLang: false },
];

const LanguageSelector = ({ disabled = false, onChange, locale, sm }) => {
  const items = langs
    .filter((lang) => lang.systemLang)
    .map((lang) => ({ value: lang.locale, title: i18n(lang.labelKey), icon: <LanguageIcon language={lang.lang} /> }));

  const handleSelectLanguage = (lang) => {
    onChange?.(lang);
  };

  return <Dropdown sm={sm} disabled={disabled} value={locale} onChange={handleSelectLanguage} items={items} />;
};

export default LanguageSelector;
